import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import {
  PaymentInformationGuestCheckoutService,
  PaymentInformationPaymentLinksService,
  PaymentInformationPlatformService,
  PaymentInformationService,
} from '../services';
import { Injectable } from '@angular/core';

export const paymentInformationServiceFactory = (
  httpClient: HttpClient,
  appConfig: AppConfigSettings,
) => {
  let service: PaymentInformationService;

  if (appConfig.getconfig('usePaymentLinkEndpoints') === 'true') {
    service = new PaymentInformationPaymentLinksService(httpClient, appConfig);
  } else if (appConfig.getconfig('useHostedPaymentsPageEndpoints') === 'true') {
    service = new PaymentInformationGuestCheckoutService(httpClient, appConfig);
  } else {
    service = new PaymentInformationPlatformService(httpClient, appConfig);
  }

  return service;
};

@Injectable({
  providedIn: 'root',
})
export class PaymentInformationServiceFactory {
  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigSettings,
  ) {}

  create() {
    return paymentInformationServiceFactory(this.httpClient, this.appConfig);
  }
}
